export enum ColumnId {
  AMOUNT_OUTSTANDING = 'amount_outstanding',
  ACCOUNT_ID = 'account_id',
  ACCOUNT_NAME = 'account_name',
  MOMENT_STATUS = 'moment_status',
  ACCOUNT_STATUS = 'account_status',
  ACCOUNT_TYPE = 'account_type',
  ACCOUNT = 'account',
  ACCOUNTS = 'accounts',
  ACCRUED_INTEREST = 'accrued_interest',
  ADVISORS = 'advisors',
  ALLOCATION = 'allocation',
  ALLOCATION_RUN_ACTION = 'allocation_run_action',
  ASK_EVAL_PRICE_DIFF = 'ask_eval_price_diff',
  ASK_G_SPREAD = 'ask_g_spread',
  ASK_I_SPREAD = 'ask_i_spread',
  ASK_OAS = 'ask_oas',
  ASK_PRICE = 'ask_price',
  ASK_YTW = 'ask_ytw',
  ASK_YTM = 'ask_ytm',
  ASK_Z_SPREAD = 'ask_z_spread',
  BANK_QUALIFIED = 'bank_qualified',
  BEST_ASK_MIN_QUANTITY = 'asks_min_quantity',
  BEST_ASK_PRICE = 'asks_price',
  BEST_ASK_QUANTITY = 'asks_qty',
  BEST_ASK_YTM = 'asks_ytm',
  BEST_ASK_YTW = 'asks_ytw',
  BEST_BID_MIN_QUANTITY = 'bids_min_quantity',
  BEST_BID_PRICE = 'bids_price',
  BEST_BID_QUANTITY = 'bids_qty',
  BEST_BID_YTM = 'bids_ytm',
  BEST_BID_YTW = 'bids_ytw',
  BID_EVAL_PRICE_DIFF = 'bid_eval_price_diff',
  BID_G_SPREAD = 'bid_g_spread',
  BID_I_SPREAD = 'bid_i_spread',
  BID_OAS = 'bid_oas',
  BID_Z_SPREAD = 'bid_z_spread',
  BOND_WARRANT = 'bond_warrant',
  CALLABLE = 'callable',
  CALL_TYPE = 'call_type',
  CALL_FREQUENCY = 'call_frequency',
  CALL_NOTICE_PERIOD = 'call_notice_period',
  CALL_NOTIFICATION_MIN = 'call_notification_min',
  CASH = 'cash',
  CLOSE_PRICE = 'close_price',
  CLOSE_PRICE_ASOF = 'close_price_asof',
  CLOSE_YTM = 'close_ytm',
  CLOSE_YTW = 'close_ytw',
  COMPLIANT_ALLOCATION = 'compliant_allocation',
  CONVERTIBLE = 'convertible',
  CONVEXITY = 'convexity',
  COST_BASIS = 'cost_basis',
  COUNTRY_DOMICILE = 'country_domicile',
  COUNTRY_ISSUE = 'country_issue',
  COUPON = 'coupon',
  COUPON_FREQUENCY = 'coupon_frequency',
  COUPON_SUBTYPE = 'coupon_subtype',
  COUPON_TYPE = 'coupon_type',
  CURRENCY = 'currency',
  CUSIP = 'cusip',
  CUSTODIAN = 'custodian',
  DATED_DATE = 'dated_date',
  DAYCOUNT = 'daycount',
  DESCRIPTION = 'description',
  DESCRIPTION_SHORT = 'description_short',
  DURATION = 'duration',
  EVAL_PRICE = 'eval_price',
  EVAL_YTM = 'eval_ytm',
  EVAL_YTW = 'eval_ytw',
  EVAL_OAS = 'mid_oas',
  FILTER_LISTS = 'filter_lists',
  FI_ASSETS = 'fi_assets',
  FITCH_OUTLOOK = 'fitch_outlook',
  FITCH_OUTLOOK_DATE = 'fitch_outlook_date',
  FITCH_RATING = 'fitch_rating',
  FITCH_RATING_DATE = 'fitch_rating_date',
  FITCH_UNDERLYING_RATING = 'fitch_underlying_rating',
  FITCH_UNDERLYING_RATING_DATE = 'fitch_underlying_rating_date',
  FIRST_COUPON_DATE = 'first_coupon_date',
  GAIN_LOSS = 'gain_loss',
  INPUT = 'input',
  IDENTIFIER = 'identifier',
  INSURED = 'insured',
  ISIN = 'isin',
  IS_AMT_APPLICABLE = 'is_amt_applicable',
  IS_PRE_REFUNDED = 'is_pre_refunded',
  IS_STRUCTURED_PRODUCT = 'is_structured_product',
  INCREMENT_AMOUNT_SECONDARY = 'increment_amount_secondary',
  ISSUE_DATE = 'issue_date',
  ISSUE_INCREMENT = 'issue_increment',
  ISSUE_MINIMUM_DENOMINATION = 'issue_minimum_denomination',
  ISSUE_PRICE = 'issue_price',
  ISSUE_SIZE = 'issue_size',
  ISSUER = 'issuer',
  LAST_COUPON_DATE = 'last_coupon_date',
  LIMIT_PRICE = 'limit_price',
  LIMIT_YTM = 'limit_ytm',
  LIMIT_YTW = 'limit_ytw',
  LIQUIDITY_INSTITUTIONAL_AGGREGATE = 'liquidity_institutional_aggregate',
  LIQUIDITY_INSTITUTIONAL_BUY = 'liquidity_institutional_buy',
  LIQUIDITY_INSTITUTIONAL_SELL = 'liquidity_institutional_sell',
  LIQUIDITY_MICRO_AGGREGATE = 'liquidity_micro_aggregate',
  LIQUIDITY_MICRO_BUY = 'liquidity_micro_buy',
  LIQUIDITY_MICRO_SELL = 'liquidity_micro_sell',
  LIQUIDITY_RETAIL_AGGREGATE = 'liquidity_retail_aggregate',
  LIQUIDITY_RETAIL_BUY = 'liquidity_retail_buy',
  LIQUIDITY_RETAIL_SELL = 'liquidity_retail_sell',
  LOWEST_RATING = 'lowest_rating',
  MARKET_SPREAD_PRICE = 'market_spread_price',
  MARKET_SPREAD_YTM = 'market_spread_ytm',
  MARKET_SPREAD_YTW = 'market_spread_ytw',
  MARKET_VALUE = 'market_value',
  MARKET_WEIGHT = 'weight',
  MATURITY_DATE = 'maturity_date',
  MATURITY_IN_DAYS = 'maturity_in_days',
  MID_G_SPREAD = 'mid_g_spread',
  MID_I_SPREAD = 'mid_i_spread',
  MID_Z_SPREAD = 'mid_z_spread',
  MUNI_OBLIGOR_STATE = 'muni_obligor_state',
  MUNICIPAL_STATE = 'municipal_state',
  MUNICIPAL_TAXABLE_FEDERAL = 'municipal_taxable_federal',
  MUNICIPAL_TYPE = 'municipal_type',
  MONEY_MANAGER = 'money_manager',
  MOODY_RATING = 'moodys_rating',
  MOODY_RATING_DATE = 'moodys_rating_date',
  MOODY_UNDERLYING_RATING = 'moodys_underlying_rating',
  MOODY_UNDERLYING_RATING_DATE = 'moodys_underlying_rating_date',
  MOODY_OUTLOOK = 'moodys_outlook',
  MOODY_OUTLOOK_DATE = 'moodys_outlook_date',
  NAICS_SECTOR = 'naics_sector',
  NAICS_SUBSECTOR = 'naics_subsector',
  NET_MONEY = 'net_money',
  NEXT_CALL_DATE = 'next_call_date',
  NEXT_CALL_PRICE = 'next_call_price',
  NEXT_COUPON_DATE = 'next_coupon_date',
  ORIGINAL_ISSUE_DATE = 'original_issue_date',
  PAR_VALUE = 'par_value',
  PERPETUAL = 'perpetual',
  PRICE = 'price',
  PRINCIPAL_FACTOR = 'principal_factor',
  PRINCIPAL_VALUE = 'principal_value',
  PRIVATE_PLACEMENT = 'private_placement',
  PROPOSED_AMOUNT = 'proposed_amount',
  PROPOSAL_STATUS = 'proposal_status',
  PURPOSE = 'purpose',
  PUTTABLE = 'puttable',
  QUANTITY = 'quantity',
  REG_S = 'reg_s',
  RESET_FREQUENCY = 'float_reset_frequency',
  RULE_144A = 'is_144a',
  SCORE = 'objective_score',
  SECTOR = 'sector',
  SECURITY_TYPE = 'security_type',
  SELL_BUTTON = 'sell_button',
  SENIORITY = 'seniority',
  SETTLEMENT_CONVENTION = 'settlement_convention',
  SINKING_FUND = 'sinking_fund',
  SLEEVE_TYPE = 'sleeve_type',
  SP_CREDITWATCH = 'sp_creditwatch',
  SP_CREDITWATCH_DATE = 'sp_creditwatch_date',
  SP_OUTLOOK = 'sp_outlook',
  SP_OUTLOOK_DATE = 'sp_outlook_date',
  SP_RATING = 'sp_rating',
  SP_RATING_DATE = 'sp_rating_date',
  SP_UNDERLYING_RATING = 'sp_underlying_rating',
  SP_UNDERLYING_RATING_DATE = 'sp_underlying_rating_date',
  SPREAD_TO_EVAL = 'spread_to_eval',
  STATUS = 'status',
  TAX_EQUIVALENT_LIMIT_YTW = 'tax_effective_limit_ytw',
  POST_TAX_LIMIT_YTW = 'post_tax_limit_ytw',
  TAX_STATE = 'tax_state',
  TICKER = 'ticker',
  TOTAL_VALUE = 'total_value',
  TRACE_ELIGIBLE = 'trace_eligible',
  TRADING_STATUS = 'do_not_trade',
  TREASURY_BENCHMARK = 'treasury_benchmark',
  TREASURY_SUBTYPE = 'treasury_subtype',

  TYPE = 'type',
  UPDATED_AT = 'updated_at',
  USE_OF_PROCEEDS = 'use_of_proceeds',
  WEIGHT = 'order_weight',
  WORKOUT_DATE = 'workout_date',
  YTM = 'ytm',
  YTW = 'ytw',
}
